<template>
  <div class="template_1">
    <!-- <form @submit.prevent="handleSubmit"> -->
      <fieldset v-for="(set, setIndex) in fields" :key="setIndex" class="fset">
        
        <div  v-if="set.deleting" class="deleting">...deleting</div>
        <span v-if="set.deletable" @click.prevent="deleteField(setIndex)" class="dicon">
          <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" class="trash_ic">
            <path d="M18 6L17.1991 18.0129C17.129 19.065 17.0939 19.5911 16.8667 19.99C16.6666 20.3412 16.3648 20.6235 16.0011 20.7998C15.588 21 15.0607 21 14.0062 21H9.99377C8.93927 21 8.41202 21 7.99889 20.7998C7.63517 20.6235 7.33339 20.3412 7.13332 19.99C6.90607 19.5911 6.871 19.065 6.80086 18.0129L6 6M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M14 10V17M10 10V17" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        
        <div class="fldata">
          <legend>
            <span class="number">{{set.number}}</span>
            <span class="desc">
              <p class="ltitle">{{set.name}}</p>
            </span>
          </legend>

          <div class="temp-row" v-for="(row, rowIndex) in fieldRows[setIndex]" :key="rowIndex">
            <div class="temp-input" 
              v-for="(field, index) in row" style="flex:1"
              :key="index" :style="['hidden'].includes(field.type) ? {display: 'none'} : {}"
              :class="{'temp1-textarea' : field.type === 'textarea'}">
    
              
              <div class="fdiv">
                <div  v-if="field.deleting" class="deleting">...deleting</div>
                <span v-if="field.deletable" @click.prevent="deleteField(setIndex,rowIndex)" class="dicon">
                  <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" class="trash_ic">
                    <path d="M18 6L17.1991 18.0129C17.129 19.065 17.0939 19.5911 16.8667 19.99C16.6666 20.3412 16.3648 20.6235 16.0011 20.7998C15.588 21 15.0607 21 14.0062 21H9.99377C8.93927 21 8.41202 21 7.99889 20.7998C7.63517 20.6235 7.33339 20.3412 7.13332 19.99C6.90607 19.5911 6.871 19.065 6.80086 18.0129L6 6M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M14 10V17M10 10V17" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>

                <div class="fdtl">
                  <label :for="field.name" v-if="!['hidden'].includes(field.type)">{{ field.label }}</label>

                  <input
                    v-if="['text', 'number', 'email','hidden','password'].includes(field.type)"
                    :type="field.type"
                    :name="field.name"
                    v-model="formData[field.name]"
                    :id="field.name"
                    v-on="listeners[field.name] || {}"
                    :readonly="field.readonly ?? false"
                  />

                  <CalendarView
                    iclass="input"
                    v-if="['date'].includes(field.type)"
                    v-model="formData[field.name]"
                    v-on="listeners[field.name] || {}"
                    :readonly="field.readonly ?? false"
                  />

                  <textarea
                    v-else-if="field.type === 'textarea'"
                    :name="field.name"
                    v-model="formData[field.name]"
                    :id="field.name"
                    rows="2" cols="80"
                    v-on="listeners[field.name] || {}"
                    :readonly="field.readonly ?? false"
                  ></textarea>
        
                  <select
                    v-else-if="field.type === 'select'"
                    :name="field.name"
                    v-model="formData[field.name]"
                    :id="field.name"
                    v-on="listeners[field.name] || {}"
                    :readonly="field.readonly ?? false"
                  >
                    <option v-for="(option, idx) in field.options" :key="idx" :value="option.value">
                      {{ option.label }}
                    </option>
                  </select>

                  <select
                    v-else-if="field.type === 'selectGroup'"
                    :name="field.name"
                    v-model="formData[field.name]"
                    :id="field.name"
                    v-on="listeners[field.name] || {}"
                    :readonly="field.readonly ?? false"
                  >
                    <optgroup v-for="(group, idx) in field.options" :key="idx" :label="group.label">
                      <option v-for="(option, idxx) in group.options" :key="idxx" :value="option.value">
                        {{ option.label }}
                      </option>
                    </optgroup>
                  </select>
        
                  <div v-else-if="field.type === 'checkbox'">
                    <div v-for="(option, idx) in field.values" :key="idx">
                      <input 
                        type="checkbox"
                        :id="`${field.name}-${idx}`"
                        :name="field.name"
                        v-model="formData[field.name]" 
                        :value="option.value"
                        v-on="listeners[field.name] || {}"
                        :readonly="field.readonly ?? false"
                      />
                      <label :for="`${field.name}-${idx}`" class="light">{{ option.label }}</label>
                    </div>
                  </div>
        
                  <div 
                    v-else-if="field.type === 'radio'">
                    <div v-for="(option, idx) in field.values" :key="idx">
                      <input 
                        type="radio"
                        :name="field.name"
                        v-model="formData[field.name]"
                        :value="option.value"
                        v-on="listeners[field.name] || {}"
                        :readonly="field.readonly ?? false"
                      />
                      <label :for="option.label" class="light">{{option.label}}</label>
                    </div>
                  </div>
        
                  <div 
                    v-else-if="field.type === 'button'">
                      <label class="dyform-switch">
                        <input type="checkbox" 
                            v-model="formData[field.name]"
                            v-on="listeners[field.name] || {}"
                            :name="field.name"
                            :id="field.name"/>
                        <span class="slider round"></span>
                      </label>
                  </div>
                  <p class="idesc" v-if="field.desc">{{field.desc}}</p>
                </div>
              </div>
              
              
              
            </div>
          </div>
        </div>
      </fieldset>

      <div class="errors" v-if="!submitting">
        <p v-for="(e,i) in errors" :key="i">{{e}}</p>
      </div>
      
      <div class="temp-row submit-btn " v-if="!submitting && !success"
      :class="{'align-items-center justify-content-between': addMore !=''}">
      <div class="btn-primary" @click="sendData" v-if="addMore !=''"> {{ addMore }} </div>
        <button 
          @click="handleSubmit" 
          :style="addMore !='' ? {width: 'auto', margin: '0', padding: '.375rem 24px'} : {}"
        >Submit</button>
      </div>
      <div class="temp-row success" v-if="success" style="justify-content: center">
        <p>Form upload successful</p>
      </div>
      <div class="temp-row submit-btn" v-if="submitting" >
        <img src="@/assets/img/ajldr.gif" style="width:100px"/>
      </div>
  </div>
</template>
  
  
<script>
import { ref, computed, defineComponent, onMounted, watchEffect } from 'vue';
import CalendarView from "@/components/CalendarView.vue";

export default defineComponent({
  components: { CalendarView },
  props: {
    fields: {
      type: Array,
      required: true
    },
    columns: {
      type: Number,
      default: 1 // Number of columns per row
    },
    submitting:{
      type:Boolean,
      default:false,
    },
    success:{
      type:Boolean,
      default:false,
    },
    errors:{
      type:Array
    },
    addMore:{
      type:String,
      default:""
    },
    listeners: {
      type: Object, // Parent can pass an object of listeners
      default: () => ({}),
    }
  },
  setup(props, { emit }) {
    const formData = ref({}); // To hold form data

    // Helper function to initialize or reinitialize form data
    const initializeFormData = () => {
      const data = {};
      props.fields.forEach(set => {
        set.data.forEach(field => {
          if (field.type === 'checkbox') {
            // initialize as an array
            data[field.name] = Array.isArray(field.value) ? field.value : [];
          } else {
            data[field.name] = field.value || '';
          }
        });
      });
      formData.value = data; // Update formData
    };

    // Initialize form data on mount
    onMounted(initializeFormData);

    // Use watchEffect to reactively update formData when fields prop changes
    watchEffect(() => {
      initializeFormData(); // Reinitialize form data when fields change
    });

    // Computed property for splitting fields into rows based on columns
    const fieldRows = computed(() => {
      const rows = [];
      props.fields.forEach(set => {
        const rowsForSet = [];
        for (let i = 0; i < set.data.length; i += props.columns) {
          rowsForSet.push(set.data.slice(i, i + props.columns));
        }
        rows.push(rowsForSet);
      });
      return rows;
    });

    // Handle form submission
    const handleSubmit = () => {
      emit('submit', { ...formData.value}); // Emit form data to parent component
    };

    const sendData = () => {
      emit('sendData', { ...formData.value});
    };

    function deleteField(setIndex, fieldIndex=null) {
      const updatedSets = JSON.parse(JSON.stringify(this.fields));
      var deletedField = updatedSets.splice(setIndex, 1)[0];
      if(fieldIndex){
        deletedField = updatedSets[setIndex].data.splice(fieldIndex, 1)[0];
      }

      emit("field-removed", {
        updatedFormSets: updatedSets,
        deleted: {
          setIndex,
          fieldIndex,
          field: deletedField,
        },
        data:{ ...formData.value}
      });
    }

    return { formData, fieldRows, handleSubmit,sendData,deleteField };
  }
});
</script>


<style scoped>
*, *:before, *:after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

body {font-family: 'Nunito', sans-serif; color: var(--black);}
p,label{color: var(--black);}
.temp-row{display: flex; gap: 5px; margin-bottom: 10px;}
form {width:100%}

h1 {margin: 0 0 30px 0;text-align: center;}

input[type="text"],
input[type="password"],
input[type="date"],
input[type="datetime"],
input[type="email"],
input[type="number"], :deep(.input),
input[type="search"],
input[type="tel"],
input[type="time"],
input[type="url"],
textarea,
select {
  background: rgba(255,255,255,0.1);
  border: none;
  font-size: 16px;
  height: auto;
  margin: 0;
  outline: 0;
  padding: 15px;
  width: 100%;
  background-color: var(--input-bg);
  color: #8a97a0;
  box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
  margin: 5px 0;
}

input[type="radio"],
input[type="checkbox"] {
  margin: 0 4px 8px 0;
}

select {
  padding: 15px;
  border-radius: 2px;
}

.submit-btn{display:flex; justify-content: center; width:100%;padding: 0 15px;}
button {width:100%; font-weight: 500;
  background: var(--primary-color);
  color: var(--white-color);
  box-shadow: none;
  border: 0;
  margin: 20px auto;
  padding: 19px 39px 18px 39px;
  font-size: 18px;
  text-align: center;
  font-style: normal;
  border-radius: 5px;
}

fieldset {
  margin-bottom: 10px;
  border: none;
  padding: 0px 15px;
}

legend {margin-bottom: 10px; display: flex; align-items: center;}
legend .desc{margin-left:5px}
legend .ltitle{font-size: 1.4em; margin: 0; line-height: 1em; font-weight: bold;}

label {display: block; font-size: 14px; font-weight: bold;}

label.light {
  font-weight: 300;
  display: inline;
}

.number {
  background-color: var(--primary-color);
  color: var(--white-color);
  height: 30px;
  width: 30px;
  display: inline-block;
  font-size: 0.8em;
  margin-right: 4px;
  line-height: 30px;
  text-align: center;
  text-shadow: 0 1px 0 rgba(255,255,255,0.2);
  border-radius: 100%;
}
.errors{padding: 0px 15px;}
.errors p{background:red; color:white; margin:5px; padding:5px 10px;
  border-radius: 10px; font-weight: bold; font-size: 14px;}
.success p{background: green;
  color: white;
  padding: 10px 20px;
  border-radius: 10px;
  font-weight: bold;}

  .dyform-switch {position: relative; display: inline-block; width: 30px; height: 17px;}
  .dyform-switch input {opacity: 0; width: 0; height: 0;}
  .dyform-switch .slider {position: absolute;cursor: pointer;top: 0;left: 0;
      right: 0;bottom: 0;background-color: #ccc;-webkit-transition: .4s;transition: .4s;}
  .dyform-switch .slider:before {position: absolute; content: ""; height: 13px;
      width: 13px; left: 4px;bottom: 4px;background-color: white; top: 50%;
      transform: translateY(-55%); -webkit-transition: .4s; transition: .4s;}
  .dyform-switch input:checked + .slider {background-color: var(--primary-color);}
  .dyform-switch input:focus + .slider {box-shadow: 0 0 1px var(--primary-color);}
  .dyform-switch input:checked + .slider:before {-webkit-transform: translate(74%,-55%);
      -ms-transform: translate(74%,-55%);transform: translate(74%,-55%);}
  .dyform-switch .slider.round {border-radius: 34px;}
  .dyform-switch .slider.round:before {border-radius: 50%;}
  .fdiv, .fset{display:flex; align-items: center; position:relative}
  .deleting{position: absolute; background: var(--white-color); top: 0; left: 0; right: 0;
    bottom: 0; opacity: .7; color: var(--black); display: flex;align-items: center; 
    justify-content: center;z-index: 1;}
  .fdtl,.fldata{width:100%}
  .trash_ic{stroke:red}
  .dicon{display:flex; align-items: center; justify-content: center;
    padding: 20px 10px 0; cursor: pointer;}
  .idesc{margin: 0; font-size: 11px; color: var(--light-text-color);}
  @media screen and (max-width: 700px) {
    .temp-row{display: block;}
  }
</style>
  